// => GET licenses
const GET_LICENSES = "/licenses";

export const licenseEndpoints = {
    GET_LICENSES,
};
